import {
  Text,
  Banner,
  ListItem,
  Primary13SemiBold,
  UnorderedList
} from '@sequencehq/core-components'
import { QuoteContentBanner } from 'modules/Cube/view/layouts/quote/QuoteContentColumn/QuoteContentBanner'
import { useValidationBanner } from './useValidationBanner'

export const ValidationBanner = () => {
  const { isVisible, validationMessages, nextStatusLabel } =
    useValidationBanner()

  if (!isVisible) {
    return null
  }

  return (
    <QuoteContentBanner data-testid="quote.validationBanner">
      <Banner variant="error">
        <Text {...Primary13SemiBold} color="inherit" marginBottom="4px">
          Before {nextStatusLabel}
        </Text>

        <UnorderedList>
          {validationMessages.map(message => (
            <ListItem key={message}>{message}</ListItem>
          ))}
        </UnorderedList>
      </Banner>
    </QuoteContentBanner>
  )
}
